(() => {
  const initTabs = (root) => root.querySelectorAll('.tabs__wrapper').forEach((tabs, groupIndex) => {
    if (tabs.dataset.mpNativeTabsReady === 'true') return;
    const navs = [...tabs.querySelectorAll(':scope > .tabs__navs-wrapper .tabs__nav')];
    const panels = [...tabs.querySelectorAll(':scope > .core__group--items > .tab__item')];
    if (!navs.length || navs.length !== panels.length) return;
    tabs.dataset.mpNativeTabsReady = 'true';
    const activate = (index, focus = false) => {
      navs.forEach((nav, i) => {
        const active = i === index;
        nav.classList.toggle('ecom-item-active', active);
        nav.setAttribute('aria-selected', String(active));
        nav.tabIndex = active ? 0 : -1;
        panels[i].classList.toggle('ecom-item-active', active);
        panels[i].hidden = !active;
      });
      if (focus) navs[index].focus();
    };
    navs.forEach((nav, index) => {
      const panel = panels[index];
      nav.id ||= 'mp-native-tab-' + groupIndex + '-' + index;
      panel.id ||= 'mp-native-panel-' + groupIndex + '-' + index;
      nav.setAttribute('role','tab'); nav.setAttribute('aria-controls',panel.id);
      panel.setAttribute('role','tabpanel'); panel.setAttribute('aria-labelledby',nav.id);
      nav.addEventListener('click', () => activate(index));
      nav.addEventListener('keydown', (event) => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        let next = event.key === 'Home' ? 0 : event.key === 'End' ? navs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + navs.length) % navs.length;
        activate(next, true);
      });
    });
    tabs.querySelector('.tabs__navs')?.setAttribute('role','tablist');
    activate(Math.max(0, navs.findIndex((nav) => nav.classList.contains('ecom-item-active'))));
  });
  const initAccordions = (root) => root.querySelectorAll('.ecom__accordion').forEach((accordion, groupIndex) => {
    if (accordion.dataset.mpNativeAccordionReady === 'true') return;
    accordion.dataset.mpNativeAccordionReady = 'true';
    const items = [...accordion.querySelectorAll(':scope > .core__group--items > .ecom-accordion__item')];
    items.forEach((item, index) => {
      const trigger = item.querySelector(':scope > .ecom-accordion__title');
      const panel = item.querySelector(':scope > .ecom-accordion__body');
      if (!trigger || !panel) return;
      trigger.id ||= 'mp-native-accordion-' + groupIndex + '-' + index;
      panel.id ||= 'mp-native-accordion-panel-' + groupIndex + '-' + index;
      trigger.setAttribute('role','button'); trigger.tabIndex = 0; trigger.setAttribute('aria-controls',panel.id);
      panel.setAttribute('role','region'); panel.setAttribute('aria-labelledby',trigger.id);
      const setOpen = (open) => {
        item.classList.toggle('ecom-item-active', open); trigger.classList.toggle('ecom-item-active', open);
        trigger.setAttribute('aria-expanded',String(open)); panel.hidden = !open;
      };
      const toggle = () => {
        const open = trigger.getAttribute('aria-expanded') !== 'true';
        items.forEach((other) => {
          if (other === item) return;
          const otherTrigger = other.querySelector(':scope > .ecom-accordion__title');
          const otherPanel = other.querySelector(':scope > .ecom-accordion__body');
          other.classList.remove('ecom-item-active'); otherTrigger?.classList.remove('ecom-item-active');
          otherTrigger?.setAttribute('aria-expanded','false'); if (otherPanel) otherPanel.hidden = true;
        });
        setOpen(open);
      };
      trigger.addEventListener('click',toggle);
      trigger.addEventListener('keydown',(event)=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();toggle();}});
      setOpen(item.classList.contains('ecom-item-active') || trigger.classList.contains('ecom-item-active'));
    });
  });
  const initDragLists = (root) => root.querySelectorAll('.element__featured--wrapper-list').forEach((list) => {
    if (list.dataset.mpNativeDragReady === 'true') return;
    list.dataset.mpNativeDragReady = 'true';
    let pointerId = null, startX = 0, startScroll = 0;
    const stop = () => { pointerId = null; list.classList.remove('is-dragging'); };
    list.addEventListener('pointerdown',(event)=>{if(event.pointerType==='touch')return;pointerId=event.pointerId;startX=event.clientX;startScroll=list.scrollLeft;list.setPointerCapture?.(pointerId);list.classList.add('is-dragging');});
    list.addEventListener('pointermove',(event)=>{if(event.pointerId===pointerId)list.scrollLeft=startScroll-(event.clientX-startX);});
    list.addEventListener('pointerup',stop);list.addEventListener('pointercancel',stop);list.addEventListener('lostpointercapture',stop);
  });
  const initSliders = (root) => root.querySelectorAll('.ecom-swiper-container').forEach((slider, sliderIndex) => {
    if (slider.dataset.mpNativeSliderReady === 'true') return;
    const controlsScope = slider.closest('.ecom-slider--container, .ecom-collection__product-container, .ecom-testimonials--container') || slider;
    slider.classList.add('ecom-swiper-initialized', 'ecom-swiper-horizontal', 'ecom-swiper-container-initialized');
    controlsScope.classList.add('ecom-swiper-initialized-wrapper');
    const track = slider.querySelector(':scope > .ecom-swiper-wrapper');
    if (!track) {
      slider.style.opacity='1'; slider.style.visibility='visible';
      controlsScope.style.opacity='1'; controlsScope.style.visibility='visible';
      return;
    }
    const slides = [...track.children].filter((item)=>item.classList.contains('ecom-swiper-slide'));
    if (slides.length < 2) {
      slider.style.opacity='1'; slider.style.visibility='visible';
      track.style.opacity='1'; track.style.visibility='visible';
      controlsScope.style.opacity='1'; controlsScope.style.visibility='visible';
      slides.forEach((slide)=>{slide.style.opacity='1';slide.style.visibility='visible';});
      return;
    }
    slider.dataset.mpNativeSliderReady = 'true';
    controlsScope.dataset.mpNativeCarouselRoot = 'true';
    let options = {};
    try { options = JSON.parse(slider.getAttribute('data-option-swiper') || '{}'); } catch (_) {}
    slider.style.overflow='hidden'; track.style.display='flex'; track.style.transition='transform .35s ease'; track.style.willChange='transform';
    let index=0,perView=1,startX=0,pointerId=null,timer=null;
    const valueAt = () => {
      if (track.hasAttribute('data-grid-column')) return innerWidth>1024?Number(track.dataset.gridColumn||4):innerWidth>767?Number(track.dataset.gridColumnTablet||2):Number(track.dataset.gridColumnMobile||1);
      const bp=options.breakpoints||{};
      const selected=Object.keys(bp).map(Number).filter(n=>n<=innerWidth).sort((a,b)=>b-a)[0];
      return Number((selected!=null?bp[selected]?.slidesPerView:null) || options.slidesPerView || 1);
    };
    const step = (next) => {
      const max=Math.max(0,slides.length-perView);
      index=options.loop?(next<0?max:next>max?0:next):Math.max(0,Math.min(max,next));
      update();
    };
    const update = () => {
      perView=Math.max(1,valueAt());
      const styles=getComputedStyle(track);const gap=Number(options.spaceBetween)||parseFloat(styles.columnGap||styles.gap)||0;
      slides.forEach((slide)=>{slide.style.flex='0 0 calc((100% - '+gap*(perView-1)+'px) / '+perView+')';});
      index=Math.min(index,Math.max(0,slides.length-perView));
      track.style.gap=gap+'px';
      track.style.transform='translate3d('+(-index*(slider.clientWidth+gap)/perView)+'px,0,0)';
      const prev=controlsScope.querySelector('.ecom-swiper-button-prev'),next=controlsScope.querySelector('.ecom-swiper-button-next');
      if(prev){prev.disabled=!options.loop&&index===0;prev.setAttribute('aria-label','Previous slide');}
      if(next){next.disabled=!options.loop&&index>=slides.length-perView;next.setAttribute('aria-label','Next slide');}
      const pagination=controlsScope.querySelector('.ecom-swiper-pagination');
      if(pagination&&pagination.children.length!==Math.max(1,slides.length-perView+1)){
        pagination.replaceChildren();
        for(let i=0;i<=Math.max(0,slides.length-perView);i++){const b=document.createElement('button');b.type='button';b.className='ecom-swiper-pagination-bullet';b.setAttribute('aria-label','Go to slide '+(i+1));b.addEventListener('click',()=>step(i));pagination.appendChild(b);}
      }
      [...(pagination?.children||[])].forEach((b,i)=>b.classList.toggle('ecom-swiper-pagination-bullet-active',i===index));
    };
    controlsScope.querySelector('.ecom-swiper-button-prev')?.addEventListener('click',()=>step(index-1));
    controlsScope.querySelector('.ecom-swiper-button-next')?.addEventListener('click',()=>step(index+1));
    track.addEventListener('pointerdown',(event)=>{pointerId=event.pointerId;startX=event.clientX;track.setPointerCapture?.(pointerId);});
    track.addEventListener('pointerup',(event)=>{if(event.pointerId!==pointerId)return;const delta=event.clientX-startX;pointerId=null;if(Math.abs(delta)>40)step(index+(delta<0?1:-1));});
    track.addEventListener('pointercancel',()=>{pointerId=null;});
    new ResizeObserver(update).observe(slider);update();
    const autoplay=options.autoplay?.enabled===true||options.autoplay===true;
    if(autoplay){const delay=Number(options.autoplay?.delay)||5000;timer=setInterval(()=>{if(!document.hidden)step(index+1);},delay);slider.addEventListener('mouseenter',()=>clearInterval(timer),{once:true});}
  });
  const initSimpleCart = (root) => root.querySelectorAll('a.ecom-ajax-cart-simple[data-id]').forEach((link) => {
    if (link.dataset.mpNativeCartReady === 'true') return;
    link.dataset.mpNativeCartReady = 'true'; let busy=false;
    link.addEventListener('click',async(event)=>{
      if(busy)return;event.preventDefault();busy=true;link.setAttribute('aria-busy','true');link.setAttribute('aria-disabled','true');
      try{const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(link.dataset.id),quantity:1}]})});if(!response.ok)throw new Error('cart add failed');await response.json();document.dispatchEvent(new CustomEvent('cart:refresh:opend'));}
      catch(_){location.assign(link.href);}
      finally{busy=false;link.removeAttribute('aria-busy');link.removeAttribute('aria-disabled');}
    });
  });
  const init = (root) => {initTabs(root);initAccordions(root);initDragLists(root);initSliders(root);initSimpleCart(root);};
  const boot = () => document.querySelectorAll('[data-mp-native-page]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',(event)=>{const root=event.target.closest?.('[data-mp-native-page]')||event.target.querySelector?.('[data-mp-native-page]');if(root)init(root);});
})();
